import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/facture")({
	component: FactureLayout,
});

function FactureLayout() {
	return <Outlet />;
}
